































































































import Vue from 'vue'
import { currency } from '@/helper/constants'
import { adminMode } from '@/helper/permission.helper'
export default Vue.extend({
  props: {
    upsellOffer: {
      type: Object
    },
    offer: {
      type: Object
    },
    upsellSettings: {
      type: Object
    },
    showCheckoutForm: Boolean,
    offerAlreadyPurchased: Boolean,
    url: String
  },
  data() {
    currency
    return {
      currency
    }
  },
  computed: {
    checkoutSettings(): object {
      return this.upsellSettings?.checkoutSettings || {}
    },
    upsellDetails(): object {
      return this.upsellSettings?.upsellDetails || {}
    },
    backgroundVisibility(): boolean {
      return this.upsellDetails?.backgroundVisibility || false
    },
    titleAlignment(): string {
      if (this.upsellDetails?.title?.alignment) {
        return `text-${this.upsellDetails.title.alignment}`
      }
      return 'text-center'
    },
    subTitleAlignment(): string {
      if (this.upsellDetails?.subTitle?.alignment) {
        return `text-${this.upsellDetails.subTitle.alignment}`
      }
      return 'text-center'
    },
    isAdmin() {
      return adminMode()
    }
  }
})
